// Display classification only: never rewrite historical section counts or model records.
const WIDTH_PATTERN = '^([0-9]{2})(?:\\s*[xX×]\\s*[0-9]{2,3}|[0-9]{2,3})$';
const usefulSerial = value => !['', 'N/A', 'NA', 'NONE', '-', '0'].includes(String(value || '').trim().toUpperCase());
function homeClassification(unit = {}) {
  const stored = Number(unit.numberOfSections);
  const declared = [1, 2, 3].includes(stored) ? stored : null;
  const size = String(unit.sizeOverall || unit.model?.boxSize || '').trim();
  const match = size.match(new RegExp(WIDTH_PATTERN));
  const width = match ? Number(match[1]) : null;
  const serialSections = usefulSerial(unit.serialC) ? 3 : usefulSerial(unit.serialB) ? 2 : null;
  const inferred = serialSections || (width ? (width <= 18 ? 1 : 2) : null);
  const candidate = declared || inferred;
  const conflict = Boolean((declared && serialSections && serialSections > declared) ||
    (candidate && width && ((candidate === 1 && width > 18) || (candidate > 1 && width <= 18))));
  return {
    sections: conflict ? null : candidate,
    needsReview: conflict,
    basis: conflict ? 'Section count, serials or overall width disagree. Review the unit.' :
      declared ? 'Stored section count' : serialSections ? 'Inferred from section serials' : width ? 'Inferred from overall width' : 'Section count and overall size are missing'
  };
}
function homeTypeLabel(unit = {}) {
  const result = Object.prototype.hasOwnProperty.call(unit, 'effectiveNumberOfSections') ?
    { sections: unit.effectiveNumberOfSections, needsReview: unit.homeTypeNeedsReview } : homeClassification(unit);
  return result.needsReview ? 'Needs review' : ({ 1: 'Single wide', 2: 'Double wide', 3: 'Triple wide' })[result.sections] || 'Other / unspecified';
}
module.exports = { WIDTH_PATTERN, homeClassification, homeTypeLabel };
